var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 10.8335C19.1665 13.4857 20.2201 16.0292 22.0954 17.9046C23.9708 19.7799 26.5143 20.8335 29.1665 20.8335C31.8187 20.8335 34.3622 19.7799 36.2376 17.9046C38.1129 16.0292 39.1665 13.4857 39.1665 10.8335C39.1665 8.18133 38.1129 5.63779 36.2376 3.76243C34.3622 1.88706 31.8187 0.833496 29.1665 0.833496C26.5143 0.833496 23.9708 1.88706 22.0954 3.76243C20.2201 5.63779 19.1665 8.18133 19.1665 10.8335V10.8335Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 15.8335V5.8335",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 5.8335L25.4165 9.5835",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 5.8335L32.9165 9.5835",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 27.5002H35.833",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.833 22.5002V30.8336C35.833 31.2756 35.6574 31.6995 35.3449 32.0121C35.0323 32.3247 34.6084 32.5002 34.1663 32.5002H2.49967C2.05765 32.5002 1.63372 32.3247 1.32116 32.0121C1.0086 31.6995 0.833008 31.2756 0.833008 30.8336V9.16691C0.833008 8.72488 1.0086 8.30096 1.32116 7.9884C1.63372 7.67584 2.05765 7.50024 2.49967 7.50024H15.833",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 39.1669C14.8427 37.2606 15.717 34.9292 15.833 32.5002",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 39.1669C21.8233 37.2606 20.949 34.9292 20.833 32.5002",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 39.1667H25.833",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDesktop);
export default __webpack_public_path__ + "static/media/upload-desktop.1a4918ffd56cbdb625791437a18a97a8.svg";
export { ForwardRef as ReactComponent };